// extracted by mini-css-extract-plugin
export default {"mainCertificationsHeader":"CertificationsHeader_mainCertificationsHeader__D5KPC","pageSubHeading":"CertificationsHeader_pageSubHeading__rFnyZ"};